"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BackfillCacheProvider () {
        return _BackfillCacheProvider.BackfillCacheProvider;
    },
    get RemoteFallbackCacheProvider () {
        return _RemoteFallbackCacheProvider.RemoteFallbackCacheProvider;
    },
    get getCacheDirectory () {
        return _getCacheDirectory.getCacheDirectory;
    },
    get getCacheDirectoryRoot () {
        return _getCacheDirectory.getCacheDirectoryRoot;
    },
    get getLogsCacheDirectory () {
        return _getCacheDirectory.getLogsCacheDirectory;
    }
});
const _BackfillCacheProvider = require("./providers/BackfillCacheProvider.js");
const _RemoteFallbackCacheProvider = require("./providers/RemoteFallbackCacheProvider.js");
const _getCacheDirectory = require("./getCacheDirectory.js");
